module.exports = __webpack_public_path__ + "img/logo.3353820d.png";